module.exports = require("./../../_gen/starling/core/StatsDisplay");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/core/StatsDisplay.js
// module id = 159
// module chunks = 0